module.exports = __webpack_public_path__ + "img/code_kefu.bc0ca272.png";